import { useEffect } from "react";

export const useHideRideMenu = (shouldRun) => {
  if (typeof shouldRun !== "function") {
    throw new Error(
      `Expected a function as first argument, but received: ${typeof shouldRun}`
    );
  }

  useEffect(() => {
    let result;
    try {
      result = shouldRun();
    } catch (err) {
      return;
    }

    if (typeof result !== "boolean") {
      return;
    }

    if (!result) return;

    const hideElements = () => {
      const elements = document.querySelectorAll('[class*="ride-select-menu"][data-testid="custom-dropdown"]');

      elements.forEach((el) => {
        el.style.display = "none";
      });
    };

    hideElements();

    const observer = new MutationObserver(hideElements);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [shouldRun]);
};
